import type { EntityConfigDefinition } from '../types/entityConfig'

// Get excluded entities from build-time env var
const excludedEntities = import.meta.env.VITE_EXCLUDED_ENTITIES?.split(',').map((e: string) => e.trim()) || []

// Auto-import all entity configurations
const entityConfigs: Record<string, EntityConfigDefinition> = {}

// Import all .ts and .js files from entities folder (support both during migration)
const entityModules = import.meta.glob<{ default: EntityConfigDefinition }>('./entities/*.{js,ts}', { eager: true })

for (const path in entityModules) {
  const module = entityModules[path]
  const config = module.default
  if (config && config.name && !excludedEntities.includes(config.name)) {
    entityConfigs[config.name] = config
  }
}

export const getEntityConfig = (entityName: string): EntityConfigDefinition | Record<string, never> => {
  return entityConfigs[entityName] || {}
}

export const getAllEntityConfigs = (): Record<string, EntityConfigDefinition> => {
  return entityConfigs
}

export const isEntityEnabled = (entityName: string): boolean => {
  return !excludedEntities.includes(entityName)
}
